/** Gate for the on-screen debug panel.
 *
 * The panel is a cashier-facing surface we DON'T want real staff to see, so it's off by default.
 * It's on automatically under the Vite dev server, and can be turned on against any deployed
 * build with `?debug=1` (persisted to localStorage so it survives the POS stripping the query
 * string on reload). `?debug=0` turns it back off.
 */
const STORAGE_KEY = 'badger_debug'

export function isDebugEnabled(): boolean {
  try {
    const param = new URLSearchParams(window.location.search).get('debug')
    if (param === '1' || param === 'true') localStorage.setItem(STORAGE_KEY, '1')
    else if (param === '0' || param === 'false') localStorage.removeItem(STORAGE_KEY)
    if (localStorage.getItem(STORAGE_KEY) === '1') return true
  } catch {
    // localStorage can be unavailable (private mode / sandboxed web view); fall through.
  }
  return import.meta.env.DEV
}
